<template>
  <div v-if="payrollTypeSummary.length > 0">
    <!-- Payroll type summary with comma-separated values -->

    <strong>Zugewiesene Zeiten je Abrechnungsart: </strong>
    <span
      v-for="(payrollType, index) in payrollTypeSummary"
      :key="payrollType.id"
    >
      <strong>{{ payrollType.title }}:</strong>
      {{ payrollType.totalAssignedTimeText
      }}<span v-if="index < payrollTypeSummary.length - 1">, </span>
    </span>
  </div>
</template>

<script>
export default {
  name: "payroll-type-time-summary",
  props: {
    attendances: {
      type: Array,
      default: () => [],
    },
    payrollTypes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    payrollTypeSummary() {
      if (!this.attendances || this.attendances.length === 0) {
        return [];
      }

      const payrollTypeTotals = {};

      // Initialize all payroll types with 0 time
      this.payrollTypes.forEach((payrollType) => {
        payrollTypeTotals[payrollType.id] = {
          title: payrollType.title,
          totalMinutes: 0,
          id: payrollType.id,
        };
      });

      // Calculate total time for each payroll type
      this.attendances.forEach((attendance) => {
        // Only count present attendees (status "1")
        if (
          attendance.attendanceStatus === "1" &&
          attendance.payrollType &&
          attendance.payrollType.id
        ) {
          const payrollTypeId = attendance.payrollType.id;

          // Calculate duration in minutes
          if (
            attendance.duration.start.date &&
            attendance.duration.start.time &&
            attendance.duration.end.date &&
            attendance.duration.end.time
          ) {
            const startDateTime = new Date(
              `${attendance.duration.start.date}T${attendance.duration.start.time}`
            );
            const endDateTime = new Date(
              `${attendance.duration.end.date}T${attendance.duration.end.time}`
            );

            if (
              !isNaN(startDateTime.getTime()) &&
              !isNaN(endDateTime.getTime()) &&
              endDateTime > startDateTime
            ) {
              const durationMinutes = Math.round(
                (endDateTime - startDateTime) / (1000 * 60)
              );

              if (payrollTypeTotals[payrollTypeId]) {
                payrollTypeTotals[payrollTypeId].totalMinutes +=
                  durationMinutes;
              }
            }
          }
        }
      });

      // Convert to array and filter out 0 values, format time text
      return Object.values(payrollTypeTotals)
        .filter((payrollType) => payrollType.totalMinutes > 0)
        .map((payrollType) => ({
          ...payrollType,
          totalAssignedTimeText: this.formatMinutesToTimeText(
            payrollType.totalMinutes
          ),
        }));
    },
  },
  methods: {
    formatMinutesToTimeText(totalMinutes) {
      if (totalMinutes === 0) return "0 min";

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      let result = [];
      if (hours > 0) {
        result.push(`${hours} h`);
      }
      if (minutes > 0) {
        result.push(`${minutes} min`);
      }

      return result.join(" ");
    },
  },
};
</script>
